import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ressourcesMenu"]

  closeRessourcesMenu() {
    this.ressourcesMenuTarget.classList.remove("active")
  }

  showRessourcesMenu(e) {
    e.preventDefault()
    this.ressourcesMenuTarget.classList.add("active")
  }
}
